"use client";

import { Provider } from 'react-redux';
import store from '@/lib/store'

export default function ReduxProvider({ children }) {;

    return (
        <Provider store={store}>
            <div>
                {children}
            </div>
        </Provider>
    )
}